const a = "APP_VERSION", t = (o) => {
  window.localStorage.setItem(a, o);
}, n = () => window.localStorage.getItem(a), r = (o) => {
  const e = n();
  (!e || e !== o) && (window.localStorage.clear(), t(o));
}, s = () => window.location.hostname.replace("www.", "");
export {
  n as a,
  s as b,
  r as g
};
